type NestedValues<T> = { [K in keyof T]: T[K][keyof T[K]] }[keyof T];

export const ADMIN_OPERATIONS = {
  externalService: {
    list: "admin.externalService.list",
  },
  systemAdmin: {
    list: "admin.systemAdmin.list",
    get: "admin.systemAdmin.get",
    setTemporaryPassword: "admin.systemAdmin.setTemporaryPassword",
    create: "admin.systemAdmin.create",
    update: "admin.systemAdmin.update",
    delete: "admin.systemAdmin.delete",
    bulkDelete: "admin.systemAdmin.bulkDelete",
  },
  tenant: {
    list: "admin.tenant.list",
    create: "admin.tenant.create",
    get: "admin.tenant.get",
    delete: "admin.tenant.delete",
    update: "admin.tenant.update",
    bulkDelete: "admin.tenant.bulkDelete",
    getWithBuildingTree: "admin.tenant.buildingTree.getAll",
  },
  user: {
    listByTenant: "admin.user.listByTenant",
    getByTenant: "admin.user.getByTenant",
    createByTenant: "admin.user.createByTenant",
    updateByTenant: "admin.user.updateByTenant",
    deleteByTenant: "admin.user.deleteByTenant",
    bulkDeleteByTenant: "admin.user.bulkDeleteByTenant",
    bulkUpdateByTenant: "admin.user.bulkUpdateByTenant",
    setPasswordByTenant: "admin.user.setTemporaryPasswordByTenant",
  },
  robot: {
    list: "admin.robot.list",
    get: "admin.robot.get",
    sync: "admin.robot.sync",
    update: "admin.robot.update",
    delete: "admin.robot.delete",
    bulkAssignToTenant: "admin.robot.bulkAssignToTenant",
    bulkRemoveFromTenant: "admin.robot.bulkRemoveFromTenant",
    bulkDelete: "admin.robot.bulkDelete",
    listByTenant: "admin.robot.listByTenant",
    getByTenant: "admin.robot.getByTenant",
    updateByTenant: "admin.robot.updateByTenant",
    assignToBuilding: "admin.robot.assignToBuilding",
    removeFromBuilding: "admin.robot.removeFromBuilding",
    removeFromTenant: "admin.robot.removeFromTenant",
  },
  market: {
    create: "admin.market.createByTenant",
    update: "admin.market.updateByTenant",
    delete: "admin.market.deleteByTenant",
  },
  area: {
    create: "admin.area.createByTenant",
    update: "admin.area.updateByTenant",
    delete: "admin.area.deleteByTenant",
  },
  building: {
    create: "admin.building.createByTenant",
    update: "admin.building.updateByTenant",
    delete: "admin.building.deleteByTenant",
  },
} as const;

export type AdminOperationType = NestedValues<typeof ADMIN_OPERATIONS>;

export const ME_OPERATIOSNS = {
  me: {
    get: "user.me.get",
    update: "user.me.update",
    setBuilding: "user.building.setCurrent",
  },
  buildingTree: {
    get: "user.buildingTree.getManaged",
  },
} as const;

export type MeOperationType = NestedValues<typeof ME_OPERATIOSNS>;

export const WORKER_OPERATIONS = {
  cleaningEvent: {
    listInCurrentBuilding: "worker.cleaningEvent.listInCurrentBuilding",
    listInRobot: "worker.cleaningEvent.listInRobot",
    listInMap: "worker.cleaningEvent.listInMap",
    updateStatus: "worker.cleaningEvent.updateStatus",
    syncInCurrentBuilding: "worker.cleaningEvent.syncInCurrentBuilding",
  },
  map: {
    listInCurrentBuilding: "worker.map.listInCurrentBuilding",
    update: "worker.map.update",
    delete: "worker.map.delete",
  },
  robot: {
    listInCurrentBuilding: "worker.robot.listInCurrentBuilding",
    update: "worker.robot.update",
    updateSetting: "worker.robot.updateSetting",
    updatePartsInfo: "worker.robot.updatePartsInfo",
  },
  schedule: {
    create: "worker.schedule.create",
    update: "worker.schedule.update",
    delete: "worker.schedule.delete",
  },
} as const;
export type WorkerOperationType = NestedValues<typeof WORKER_OPERATIONS>;
